import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import PropTypes from "prop-types";

import FormAttachmentsView  from "components/FormAttachmentsView";
import { API_PROPOSAL, COLUMN_HEADER_KEYS } from "globals/constants";
import { useFormAccesses } from "hooks";
import { proposalSelectors, shellSelectors, tenantSelectors } from "store/selectors";
import { spUrl } from "utils";


const ProposalAttachmentsView = ({ setJustActivatedSectionLabel, tabsRef, formTabText, isUploading, setIsUploading }) => {
	const proposal = useSelector(proposalSelectors.proposal);
	const { fullName } = useSelector(shellSelectors.user);
	const { attachmentTypes } = useSelector(tenantSelectors.tenant);

	const formAccesses = useFormAccesses(COLUMN_HEADER_KEYS.PROPOSAL, proposal.proposalId);

	const {
		formInstance,
		attachmentsUrl,
		proposalAttachmentTypes,
	} = useMemo(() => ({
		attachmentsUrl: spUrl(`${API_PROPOSAL}/${proposal.proposalId}/attachments`),
		proposalAttachmentTypes: attachmentTypes["PROPOSAL"],
		formInstance: {
			instanceId: proposal.proposalId,
			endpoint: API_PROPOSAL,
			type: COLUMN_HEADER_KEYS.PROPOSAL
		},
	}), [ proposal, attachmentTypes ]);

	return (
		<FormAttachmentsView
			formInstance={formInstance}
			fullName={fullName}
			attachmentTypes={proposalAttachmentTypes}
			attachmentsUrl={attachmentsUrl}
			setJustActivatedSectionLabel={setJustActivatedSectionLabel}
			tabsRef={tabsRef}
			formTabText={formTabText}
			canAddAttachments={formAccesses.addContent}
			canEditAttachments={formAccesses.updateContent}
			setIsUploading={setIsUploading}
			isUploading={isUploading}
		/>
	);
};

ProposalAttachmentsView.propTypes = {
	setJustActivatedSectionLabel: PropTypes.func.isRequired,
	tabsRef: PropTypes.object
};

export default ProposalAttachmentsView;
